import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import ContentSection from "./components/ContentSection";
import ArticleSection from "./components/ArticleSection";
import FaqSection from "./components/FaqSection";
import SafetyCtaSection from "./components/SafetyCtaSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <ContentSection />
        <ArticleSection />
        <FaqSection />
        <SafetyCtaSection />
      </main>
      <Footer />
    </div>
  );
}